import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';

/** 获取计量处罚事件首页汇总（服务商） */
export const getIllegalEventSummary = () => smb_fetch(
  getAgpApiUrl('crm_task_service/agency_event', 'get_summary'),
  { method: 'POST', contentType: 'application/json', data: {} },
  true, false,
);

/** 获取计量处罚事件列表（服务商） */
export const getIllegalEventList = (data?: any) => smb_fetch(
  getAgpApiUrl('crm_task_service/agency_event', 'get_list'),
  { method: 'POST', contentType: 'application/json', data },
  true, false,
);

/** 获取计量处罚事件详情（服务商） */
export const getIllegalEventDetail = (data?: any) => smb_fetch(
  getAgpApiUrl('crm_task_service/agency_event', 'get_detail'),
  { method: 'POST', contentType: 'application/json', data },
  true, false,
);

/** 提交事件反馈（服务商，通用） */
export const submitIllegalEventFeedback = (data?: any) => smb_fetch(
  getAgpApiUrl('crm_task_service/agency_event', 'submit_feedback'),
  { method: 'POST', contentType: 'application/json', data },
  true, false,
);
